import { render, staticRenderFns } from "./RunnitModels.vue?vue&type=template&id=3d080e54&scoped=true"
import script from "./RunnitModels.vue?vue&type=script&lang=ts"
export * from "./RunnitModels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d080e54",
  null
  
)

export default component.exports